import ReactGA from 'react-ga'

const ApplicationUtil = {
	sumbitRegister: function (category, action, labelSubmit) {
		ReactGA.event({
			category: category,
			action: action,
			label: labelSubmit
		})
	},
	getUserId: function (login) {
		const idUser = parseInt(login, 36)
		return idUser
	}
}

export { ApplicationUtil }



// WEBPACK FOOTER //
// ./src/utils/ApplicationUtil.js